import { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';

export default function InvitePage() {
  const { token } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();

  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [accepting, setAccepting] = useState(false);
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Приглашение не найдено.');
      setLoading(false);
      return;
    }
    loadInvite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  async function loadInvite() {
    setLoading(true);
    setError('');
    try {
      const res = await api.get(`/auth/teacher-invitations/${token}/`);
      setInfo(res.data);
    } catch (e) {
      setError(e.response?.data?.detail || 'Приглашение недействительно или истекло.');
    } finally {
      setLoading(false);
    }
  }

  async function handleAccept() {
    if (!token) return;
    setAccepting(true);
    setError('');
    try {
      await api.post(`/auth/teacher-invitations/${token}/accept/`);
      setAccepted(true);
      // Можно сразу отправить на дашборд
      navigate('/dashboard');
    } catch (e) {
      const detail = e.response?.data?.detail || 'Не удалось принять приглашение.';
      setError(detail);
    } finally {
      setAccepting(false);
    }
  }

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Загрузка приглашения...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="invite-page">
        <h1>Приглашение</h1>
        <div className="alert alert-error">{error}</div>
        <p className="text-secondary">
          Вы можете вернуться на <Link to="/">главную страницу</Link>.
        </p>
      </div>
    );
  }

  if (!info) {
    return (
      <div className="invite-page">
        <h1>Приглашение</h1>
        <p className="text-secondary">Приглашение недоступно.</p>
      </div>
    );
  }

  const teacherName =
    (info.teacher_last_name || info.teacher_first_name
      ? `${info.teacher_last_name || ''} ${info.teacher_first_name || ''}`.trim()
      : info.teacher_username) || info.teacher_username;

  return (
    <div className="invite-page">
      <div className="page-header">
        <h1>Приглашение от преподавателя</h1>
      </div>

      <div className="card">
        <p>
          Преподаватель <strong>{teacherName}</strong> приглашает вас стать его учеником.
        </p>
        {info.note && (
          <p className="text-secondary">
            Сообщение преподавателя: <em>{info.note}</em>
          </p>
        )}

        {user ? (
          <>
            <p className="text-secondary">
              Вы вошли как <strong>{user.username}</strong>. Если это не вы, сначала выйдите из
              аккаунта.
            </p>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleAccept}
              disabled={accepting || accepted}
            >
              {accepting ? 'Присоединение...' : accepted ? 'Принято' : 'Принять приглашение'}
            </button>
          </>
        ) : (
          <>
            <p className="text-secondary">
              Чтобы принять приглашение, пожалуйста, войдите или зарегистрируйтесь.
            </p>
            <div className="invite-actions">
              <Link
                to={`/login?next=/invite/${token}`}
                className="btn btn-outline"
              >
                Войти
              </Link>
              <Link
                to={`/register?invite=${token}`}
                className="btn btn-primary"
              >
                Зарегистрироваться и присоединиться
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

